import { WINDOW_AVAILABLE } from '../redux/app';
import { ROUTER_LOCATION_CHANGED } from '../redux/route';
import get from 'lodash/get';

import type {
  EventTracking,
  LocationChangedAction,
  LocationChangedTracker,
  RouterState,
} from '../types';

export const pbr_page_load = 'pbr_page_load';

export function validateLocationChanged(action: Object): boolean {
  // Valid only if the page name has changed
  return action.data.previous_url !== action.data.current_location;
}

function locationChanged(
  action: LocationChangedAction,
  { route },
): LocationChangedTracker {
  // this is an optional param, so get is mandatory
  const previous_url = get(route, 'previousRoute.asPathPathname', null);

  return {
    previous_url,
  };
}

// Make sure you cast this before you export it in your duckling.

const tracking: EventTracking = {};
tracking[WINDOW_AVAILABLE] = locationChanged;
tracking[ROUTER_LOCATION_CHANGED] = locationChanged;

export default tracking;
